/**
 * Dishes API service
 */

import { apiClient } from './client';
import type {
  Dish,
  CreateDishRequest,
  UpdateDishRequest,
  ListDishesResponse,
} from '@/types/api';

/**
 * GET /api/dishes
 */
export async function getDishes(query?: string): Promise<ListDishesResponse> {
  const response = await apiClient.get<ListDishesResponse>('/dishes', {
    params: query ? { query } : undefined,
  });
  return response.data;
}

/**
 * GET /api/dishes/:id
 */
export async function getDishById(id: number): Promise<Dish> {
  const response = await apiClient.get<Dish>(`/dishes/${id}`);
  return response.data;
}

/**
 * POST /api/dishes
 */
export async function createDish(data: CreateDishRequest): Promise<Dish> {
  const response = await apiClient.post<Dish>('/dishes', data);
  return response.data;
}

/**
 * PATCH /api/dishes/:id
 */
export async function updateDish(
  id: number,
  data: UpdateDishRequest,
): Promise<Dish> {
  const response = await apiClient.patch<Dish>(`/dishes/${id}`, data);
  return response.data;
}

/**
 * DELETE /api/dishes/:id
 */
export async function deleteDish(id: number): Promise<void> {
  await apiClient.delete(`/dishes/${id}`);
}
